<tr class="accountSettingsSiteRow" [class.accountSettingsSiteRow--disabled]="ppSite.archived">
  <td class="settingsTable__cell" [class.settingsTable__cell--withCheckbox]="ppCanSeeArchived">
    <div class="settingsTable__siteWrapper">
      @if (ppCanSeeArchived) {
        <pp-checkbox
          ppType="solid"
          ppSize="medium"
          [class.settingsTable__checkbox--archived]="ppSite.archived"
          [class.settingsTable__checkbox]="!ppSite.archived"
          [ppChecked]="isSelected"
          (ppOnValueChange)="toggleSelected()"
          data-test="siteNameCheckbox"
        >
          <a
            ppTooltip
            [ppTitle]="ppSite.siteName"
            [ppTrimTooltip]="true"
            class="settingsTable__siteLink"
            [class.settingsTable__siteLink--disabled]="ppSite.archived"
            (click)="navigateToSite()"
            data-test="siteLink"
          >
            {{ ppSite.siteName }}
          </a>
        </pp-checkbox>
      }

      @if (!ppCanSeeArchived) {
        <a
          ppTooltip
          [ppTitle]="ppSite.siteName"
          [ppTrimTooltip]="true"
          class="settingsTable__siteLink"
          (click)="navigateToSite()"
          data-test="siteLink--noArchive"
        >
          {{ ppSite.siteName }}
        </a>
      }

      @if (ppSite.archived) {
        <div class="archivedChip" data-test="archivedChip">
          <pp-icon [ppSrc]="EIconPath.ICON_MISC_ARCHIVE_14" ppClass="setSize14" ppColor="white" />

          <span class="archivedChip__text">{{ 'archived' | ppTranslate }}</span>
        </div>
      }
    </div>
  </td>

  <td class="settingsTable__cell" data-test="numberOfUsers">
    {{ numberOfUsers }}
    {{ numberOfUsers !== 1 ? 'users' : 'user' }}
  </td>

  <td class="settingsTable__cell" data-test="pointCount">
    {{ pointCount }}
    {{ pointCount !== 1 ? 'points' : 'point' }}
  </td>

  <td class="settingsTable__cell settingsTable__column--size" data-test="totalSize">
    {{ totalSize }}
  </td>
</tr>
